/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeTableModule } from 'primeng/treetable';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { TonnageRatingsResolver } from './shared/tonnage-ratings.resolver';
import { TonnageRatingsRoutingModule } from './tonnage-ratings-routing.module';
import { TonnageRatingsComponent } from './tonnage-ratings.component';


/**
 * This TonnageRatingsModule is created for all tonnage rating information related screens.s
 * @export
 * @class TonnageRatingsModule
 */
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        OverlayPanelModule,
        DropdownModule,
        AutoCompleteModule,
        RadioButtonModule,
        SplitButtonModule,
        ReactiveFormsModule,
        CalendarModule,
        DialogModule,
        FormsModule,
        TreeTableModule,
        InputTextareaModule,
        TonnageRatingsRoutingModule
    ],
    providers: [TonnageRatingsResolver],
    declarations: [TonnageRatingsComponent],
    exports: [TonnageRatingsComponent]
})

export class TonnageRatingsModule { }
